import React, { useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { UseDailyCallReport } from "./DailyCallReport/UseDailyCallReport";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";
import { showToast } from "../../utils/toastUtils";
import { DailyCallReportFunction } from "./DailyCallReport/DailyCallReportRepo";

const DailyCallReport = () => {
  const { startPolling } = useExcelPolling();
  const [filterData, setFilterData] = useState({
    start_date: "",
    end_date: "",
    page: 1,
    limit: 10,
    search: "",
    action: "view",
  });

  const {
    data: dataForAttendance,
    isLoading,
    isSuccess,
  } = UseDailyCallReport({
    enable:
      !!filterData.start_date || !!filterData.end_date || !!filterData.search,
    param: {
      ...(filterData.start_date === ""
        ? {}
        : { startDate: filterData.start_date }),
      ...(filterData.end_date === "" ? {} : { endDate: filterData.end_date }),
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      page: filterData.page,
      limit: filterData.limit,
      action: filterData.action,
    },
  });

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const downloadExcelGet = async () => {
    const param = {
      ...(filterData.start_date === ""
        ? {}
        : { startDate: filterData.start_date }),
      ...(filterData.end_date === "" ? {} : { endDate: filterData.end_date }),
      ...(filterData.search === "" ? {} : { search: filterData.search }),
      page: filterData.page,
      limit: filterData.limit,
      action: "download",
    };

    try {
      setLoadingExcel(true);
      const response = await DailyCallReportFunction(param);
      const { success, fileDownloadId, intervalTime } = response.rowData.data || {};
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (excelStatus: string) => {
            setExcelStatus(excelStatus);
          },
          onSuccess: (url: string) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFaled: (message: string) =>
            showToast.error(
              message || "onFalied error in DailCall report excel"
            ),
          onExpired: (message: string) =>
            showToast.error(
              message || "onExpired error in  DailCall report excel"
            ),
          onDeleted: (message: string) =>
            showToast.error(
              message || "onDeleted error in DailCall report excel "
            ),
        });
      }
    } catch (error: any) {
      console.log("Error while downloading excel in DailCAll report");
    }
  };

  const handleSearch = (val: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      search: val,
    }));
  };
  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
      limit: limit,
    }));
  };

  const handleEndDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterData((prev: any) => ({
      ...prev,
      end_date: e.target.value,
    }));
  };
  const handleStartDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterData((prev: any) => ({
      ...prev,
      start_date: e.target.value,
    }));
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Daily Call Report"
        buttons={[
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        Title="Daily Call Report"
        dynamicHeightOnRowsPerPage={true}
        filterFirstApporach={
          !!filterData.start_date ||
          !!filterData.end_date ||
          !!filterData.search
        }
        data={
          (!isLoading && isSuccess && dataForAttendance?.formatedData) || []
        }
        columns={DailyCallReportColumn}
        showSpinner={isLoading}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            <label style={{ color: "black", marginTop: "7px" }}>
              Start Date
            </label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleStartDate(e)
              }
            />
            <label style={{ color: "black", marginTop: "7px" }}>End Date</label>
            <input
              type="date"
              style={{
                padding: "6px 10px",
                border: ".2px solid #ccc",
                fontSize: "14px",
                borderRadius: "4px",
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleEndDate(e)
              }
            />
          </div>
        }
        handleSearch={(e: any) => handleSearch(e)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        paginationTotalRows={
          dataForAttendance?.rowData.data.Pagination.TotalCounts || 0
        }
      />
    </div>
  );
};
export default DailyCallReport;

const DailyCallReportColumn = [
  {
    name: "Employee Code",
    selector: (row: { EmployeeCode?: string }) =>
      row.EmployeeCode ? row.EmployeeCode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Employee Name",
    selector: (row: { EmployeeName?: string }) =>
      row.EmployeeName ? row.EmployeeName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Dcr Date",
    selector: (row: { DcrDate?: string }) => (row.DcrDate ? row.DcrDate : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "Dcr Time",
    selector: (row: { DcrTime?: string }) => (row.DcrTime ? row.DcrTime : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "Agenda Name",
    selector: (row: { AgendaName?: string }) =>
      row.AgendaName ? row.AgendaName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Name",
    selector: (row: { OutletName?: string }) =>
      row.OutletName ? row.OutletName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Doctor Name",
    selector: (row: { DoctorName?: string }) =>
      row.DoctorName ? row.DoctorName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Classification",
    selector: (row: { Classification?: string }) =>
      row.Classification ? row.Classification : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Outlet Type",
    selector: (row: { OutletType?: string }) =>
      row.OutletType ? row.OutletType : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Jw Employee Code",
    selector: (row: { JwEmployeeCode?: string }) =>
      row.JwEmployeeCode ? row.JwEmployeeCode : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Jw Employee",
    selector: (row: { JwEmployee?: string }) =>
      row.JwEmployee ? row.JwEmployee : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Territory Name",
    selector: (row: { TerritoryName?: string }) =>
      row.TerritoryName ? row.TerritoryName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Town Name",
    selector: (row: { TownName?: string }) =>
      row.TownName ? row.TownName : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Created Date",
    selector: (row: { CreatedDate?: string }) =>
      row.CreatedDate ? row.CreatedDate : "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "DcrLatLong",
    selector: (row: { DcrLatLong?: string }) =>
      row.DcrLatLong ? row.DcrLatLong : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Doctors Feedback",
    selector: (row: { DoctorsFeedback?: string }) =>
      row.DoctorsFeedback ? row.DoctorsFeedback : "-",
    sortable: true,
    width: "180px",
  },
  {
    name: "Remarks",
    selector: (row: { Remarks?: string }) => (row.Remarks ? row.Remarks : "-"),
    sortable: true,
    width: "180px",
  },
  {
    name: "Business Potential Of The Doctor",
    selector: (row: { WhatIsTheBusinessPotentialOfTheDoctor?: string }) =>
      row.WhatIsTheBusinessPotentialOfTheDoctor
        ? row.WhatIsTheBusinessPotentialOfTheDoctor
        : "-",
    sortable: true,
    width: "180px",
  },
];
